var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mainContent" },
    [
      _c("nav-bar"),
      _c("ts-bar"),
      _c(_vm.leftComponent, { tag: "component" }),
      _c(_vm.rightComponent, { tag: "component" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }